/* eslint-disable camelcase */

export default (api) => {

    function getInvoices(query) {
        return api.get(`/_svc/slapi-v1/invoice/customer?${query}`);
    }

    function getInvoicesNoon(query) {
        return api.get(`/_svc/slapi-v1/invoice/noon?${query}`);
    }

    function getCreditNotes(query) {
        return api.get(`/_svc/slapi-v1/credit/customer?${query}`);
    }

    function getPayments(query) {
        return api.get(`/_svc/slapi-v1/statements?${query}`);
    }

    function getPaymentDetails(query) {
        return api.get(`/_svc/slapi-v1/statements/details?${query}`);
    }

    function getFinanceView(query) {
        return api.get(`/_svc/slapi-v1/statements/finance?${query}`);
    }

    function getOrderView(query) {
        return api.get(`/_svc/slapi-v1/statements/order?${query}`);
    }
    function exportCreditNote(query) {
        return api.get(`/_svc/slapi-v1/credit/export?${query}`);
    }
    function exportInvoice(query) {
        return api.get(`/_svc/slapi-v1/invoice/export?${query}`);
    }

    function exportStatements(query) {
        return api.get(`/_svc/slapi-v1/statements/export?${query}`);
    }

    return {
        getInvoices,
        getCreditNotes,
        getPayments,
        getFinanceView,
        getOrderView,
        exportCreditNote,
        exportInvoice,
        exportStatements,
        getInvoicesNoon,
        getPaymentDetails
    };
};



// WEBPACK FOOTER //
// ./src/services/StatementsService.js